{{ label }}
<studio-progress-spinner
  *ngIf="spinning"
  [theme]="spinnerTheme"
  [size]="spinnerSize"
></studio-progress-spinner>
